import React from "react";
import Protected from "../../components/Protected";
import { useAppSelector, useAppDispatch } from "../../hooks";
import { authenticateInternalUser } from "../../store";

type InternalAuthGuardProps = {
  children: React.JSX.Element;
};

const InternalAuthGuard = (props: InternalAuthGuardProps) => {
  const token = useAppSelector((state) => state.token);
  const dispatch = useAppDispatch();
  const authenticated = token !== null;
  if (!authenticated) {
    dispatch(authenticateInternalUser());
  }
  return <Protected isAuthorized={authenticated} outlet={props.children} />;
};

export default InternalAuthGuard;
